import React, {ReactElement} from 'react';
import {AlertTitle, Snackbar} from '@mui/material';
import {Alert} from '@customink/pigment-react';

type GroupOrderAlertType = {
  title?: string;
  message: string;
};

type ConfirmationAlertProps = {
  showSuccessAlert: boolean;
  onCloseAlert: () => void;
  groupOrderAlert: GroupOrderAlertType;
};

const AlertConfirmation: React.FC<ConfirmationAlertProps> = ({
  showSuccessAlert,
  onCloseAlert,
  groupOrderAlert
}: ConfirmationAlertProps): ReactElement => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      open={showSuccessAlert}
      autoHideDuration={4000}
      onClose={onCloseAlert}>
      <div className="successAlert-container">
        <Alert severity="success" onClose={onCloseAlert}>
          {groupOrderAlert?.title ? (
            <AlertTitle>{groupOrderAlert.title}</AlertTitle>
          ) : null}
          {groupOrderAlert?.message ? groupOrderAlert.message : null}
        </Alert>
      </div>
    </Snackbar>
  );
};

export default AlertConfirmation;
